export const SUPPORT_NUMBER = "(888) 454-3827";
export const SUPPORT_NUMBER_HREF = `tel:${SUPPORT_NUMBER}`;

export const SUPPORT_EMAIL = "support@aptihealth.com";
export const SUPPORT_EMAIL_HREF = `mailto:${SUPPORT_EMAIL}?subject=Web Support Request`;

export const CRISIS_LIFELINE_HREF = "https://988lifeline.org";
